import { SubClientSummary } from '../models/subclient.model';

/**
 * Returns true when the subgroup has employee ID enabled for invoice display.
 */
export function subclientEmployeeIdOnInvoiceEnabled(sg: SubClientSummary | undefined): boolean {
  return sg?.employeeIdOnInvoice === true;
}

/**
 * Whether the Employee ID column should show for a set of rows.
 * Pass current page items for the main list, or selected rows for bulk-selected view.
 * Returns true when any row belongs to a subgroup with employeeIdOnInvoice enabled.
 */
export function employeeIdColumnVisibleForRows(
  subgroups: SubClientSummary[],
  rows: { cCode: string }[]
): boolean {
  return rows.some((row) =>
    subclientEmployeeIdOnInvoiceEnabled(subgroups.find((s) => s.cCode === row.cCode.trim()))
  );
}

/**
 * Returns true when the subgroup's enrollment types include 'file-feed'.
 * File-feed subgroups use a different cancellation process and must not expose
 * the standard Cancel action in the portal UI.
 */
export function isFileFeedEnrollment(enrollmentTypes: string[] | undefined): boolean {
  return (enrollmentTypes ?? []).some(t => String(t).toLowerCase().trim() === 'file-feed');
}

/**
 * Returns true when the subgroup has Client Portal (`hr-portal`) enrollment AND
 * does NOT use file-feed enrollment. Used to gate bulk-cancel selection eligibility.
 */
export function subgroupAllowsHrPortalCancellation(enrollmentTypes: string[] | undefined): boolean {
  const n = (enrollmentTypes ?? []).map(t => String(t).toLowerCase().trim());
  return n.includes('hr-portal') && !n.includes('file-feed');
}
